import PropTypes from 'prop-types';
import React from 'react';
import { subscribe } from 'alfa';
import { Button, Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import XLSX from 'xlsx';

import money from '../../../helpers/money';

const formatDate = (date) => {
  if (!date) {
    return '';
  }
  const format = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };
  return Intl.DateTimeFormat('en-US', format).format(new Date(date));
};

const ExportList = ({ t, getData, account, disabled = false }) => {
  const format = ({ id, amount: value, currency, debit, src_uri, dst_uri, created_at, state, name, description }) => {
    let amount = money.toDisplay(value, currency, false);
    if (debit) {
      amount = `-${amount}`;
    }

    const { origin } = new URL(account.url);
    const sourceUri = (src_uri) ? new URL(src_uri).pathname : '';
    const isSourceInternal = src_uri.includes('internal');
    const destinationUri = (dst_uri) ? new URL(dst_uri).pathname : '';
    const isDestinationInternal = dst_uri.includes('internal');

    return {
      id,
      created_at: formatDate(created_at),
      amount,
      currency,
      state,
      name,
      description,
      source: (isSourceInternal) ? `${origin}/${sourceUri}` : sourceUri,
      destination: (isDestinationInternal) ? `${origin}/${destinationUri}` : destinationUri,
    };
  };

  const handleExport = async () => {
    const modal = Modal.info({
      title: `${t('loading')}...`,
      okButtonProps: { disabled: true },
      maskClosable: false,
      keyboard: false,
      content: (
        <div>
          <p>{t('transaction.fetch_to_export')}</p>
        </div>
      ),
    });

    const data = await getData();
    const formattedData = data.map((item) => format(item));
    const sheet = XLSX.utils.json_to_sheet(formattedData);
    const file = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(file, sheet, 'Sheet 1');
    XLSX.writeFile(file, `${account.alias} transactions.xlsx`);
    modal.destroy();
  };

  return (
    <Button icon="download" onClick={handleExport} disabled={disabled}>
      {t('export')}
    </Button>
  );
};

ExportList.propTypes = {
  account: PropTypes.shape({
    alias: PropTypes.string,
    url: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  getData: PropTypes.func,
  t: PropTypes.func,
};

export default subscribe(withTranslation()(ExportList), ['account']);
